document.addEventListener("DOMContentLoaded", () => {
    const openModalButton = document.getElementById("open-video-modal");
    const modal = document.getElementById("video-modal-tradition");
    const closeModalButton = document.getElementById("close-modal-tradition");

    const youtubeDesktop = document.getElementById("youtube-desktop");
    const youtubeMobile = document.getElementById("youtube-mobile");

    const videoDesktop = document.getElementById("video-desktop");
    const videoMobile = document.getElementById("video-mobile");

    let isPopupVisible = false;

    function getViewportWidth() {
        return window.innerWidth || document.documentElement.clientWidth;
    }

    function renderIframe() {
        const isMobile = getViewportWidth() < 768;
    
        if (isPopupVisible) {
            [youtubeDesktop, youtubeMobile].forEach((iframe) => {
                if (iframe) {
                    iframe.classList.add("hide");
                    let originalSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                    iframe.setAttribute("src", originalSrc);
                }
            });
    
            if (isMobile) {
                if (youtubeMobile && youtubeMobile.getAttribute("src").trim() !== "") {
                    let mobileSrc = youtubeMobile.getAttribute("src");
                    if (!mobileSrc.includes("&autoplay=1")) {
                        mobileSrc += "&autoplay=1";
                        youtubeMobile.setAttribute("src", mobileSrc);
                    }
                    youtubeMobile.classList.remove("hide");
                } else if (youtubeDesktop && youtubeDesktop.getAttribute("src").trim() !== "") {
                    let desktopSrc = youtubeDesktop.getAttribute("src");
                    if (!desktopSrc.includes("&autoplay=1")) {
                        desktopSrc += "&autoplay=1";
                        youtubeDesktop.setAttribute("src", desktopSrc);
                    }
                    youtubeDesktop.classList.remove("hide");
                }
            } else {
                if (youtubeDesktop && youtubeDesktop.getAttribute("src").trim() !== "") {
                    let desktopSrc = youtubeDesktop.getAttribute("src");
                    if (!desktopSrc.includes("&autoplay=1")) {
                        desktopSrc += "&autoplay=1";
                        youtubeDesktop.setAttribute("src", desktopSrc);
                    }
                    youtubeDesktop.classList.remove("hide");
                }
            }
        } else {
            [youtubeDesktop, youtubeMobile].forEach((iframe) => {
                if (iframe) {
                    let currentSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                    iframe.setAttribute("src", currentSrc);
                    iframe.classList.add("hide");
                }
            });
        }
    }
    
    function renderVideos() {
        const isMobile = getViewportWidth() < 768;

        [videoDesktop, videoMobile].forEach((video) => {
            if (video) {
                video.classList.add("hide");
                video.pause();
                video.currentTime = 0;
            }
        });

        if (isMobile && videoMobile) {
        const mobileSrc = videoMobile.querySelector("source")?.getAttribute("src") || "";
            if (mobileSrc.trim() !== "") {
                videoMobile.classList.remove("hide");
                videoMobile.play();
            } else if (videoDesktop) {
                videoDesktop.classList.remove("hide");
                videoDesktop.play();
            }
        } else if (videoDesktop) {
            const desktopSrc = videoDesktop.querySelector("source")?.getAttribute("src") || "";
            if (desktopSrc.trim() !== "") {
                videoDesktop.classList.remove("hide");
                videoDesktop.play();
            }
        }
    }

    function closeModalVideo() {
        modal.classList.add("hidden");

        [videoDesktop, videoMobile].forEach((video) => {
            if (video && !video.classList.contains("hide")) {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    function closeModalIframe() {
        isPopupVisible = false;
        modal.classList.add("hidden");

        [youtubeDesktop, youtubeMobile].forEach((iframe) => {
            if (iframe) {
                let currentSrc = iframe.getAttribute("src").replace("&autoplay=1", "");
                iframe.setAttribute("src", currentSrc);
                iframe.classList.add("hide");
            }
        });
    }

    openModalButton.addEventListener("click", (e) => {
        e.preventDefault();
        isPopupVisible = true;
        modal.classList.remove("hidden");
        renderIframe();
        renderVideos();
    });

    closeModalButton.addEventListener("click", closeModalVideo);
    closeModalButton.addEventListener("click", closeModalIframe);

    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            closeModalIframe();
            closeModalVideo();
        }
    });

    window.addEventListener("resize", renderVideos);
    window.addEventListener("resize", () => {
        if (isPopupVisible) {
            renderIframe();
        }
    });
});
